import React from "react";
import image_1 from "../../images/afro-academy/Picture15.png";
import image_2 from "../../images/afro-academy/Picture16.png";
import image_3 from "../../images/afro-academy/Picture17.png";
import image_4 from "../../images/afro-academy/Picture18.png";

const BuildCareer = () => {
  return (
    <section className="pt-7">
      <div className="ms-47 me-47 text-center">
        <h1 className="fs-56 lh-64 gilroy-bold">Build your Career</h1>
        <h2 className="fs-28 lh-30 gilroy-bold mb-4">Ready to Learn & Earn?</h2>
        <p className="fs-20 lh-30">
          With our hybrid teaching model. Learn at your own pace, when and where
          it’s convenient for you and still benefit from classroom interactions
          & stimulated learning.
        </p>
      </div>

      <div className="me-47 ms-47 py-5">
        <div className="row">
          <div className="col-lg-6 col-xl-6">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-12">
                <div className="row build-card-border p-3 p-md-5">
                  <div className="col-4 col-md-3 col-xl-2">
                    <img
                      src={image_1}
                      loading="lazy"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-8 col-md-9 col-xl-10 my-auto">
                    <p className="fs-20">Certificate</p>
                    <p className="fs-16">Value all over the world</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-12">
                <div className="row build-card-border p-3 p-md-5">
                  <div className="col-4 col-md-3 col-xl-2">
                    <img
                      src={image_2}
                      loading="lazy"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-8 col-md-9 col-xl-10 my-auto">
                    <p className="fs-20">Networking</p>
                    <p className="fs-16">Expand your network</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-12">
                <div className="row build-card-border p-3 p-md-5">
                  <div className="col-4 col-md-3 col-xl-2">
                    <img
                      src={image_3}
                      loading="lazy"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-8 col-md-9 col-xl-10 my-auto">
                    <p className="fs-20">Learn Skills</p>
                    <p className="fs-16">With unlimited courses</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-12">
                <div className="row build-card-border p-3 p-md-5">
                  <div className="col-4 col-md-3 col-xl-2">
                    <img
                      src={image_4}
                      loading="lazy"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-8 col-md-9 col-xl-10 my-auto">
                    <p className="fs-20">Expert Teachers</p>
                    <p className="fs-16">Best & Highly Qualified</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-xl-6 my-auto ps-md-5">
            <p className="fs-56 lh-64 gilroy-bold ms-md-5">
              Register your Account, Get FREE ACCESS to 66,000+{" "}
              <span className="text-orange-ryb">Templates, Tools & Tips.</span>
            </p>
          </div>
        </div>
      </div>

      <div className="bg-american-yellow text-white">
        <div className="container-fluid py-5">
          <div className="me-47 ms-47">
            <p className="fs-20 lh-30">
              <span className="gilroy-bold">
                Start learning for FREE with limited time offer.
              </span>{" "}
              Hand-picked Instructor and expertly crafted courses, designed for
              the modern engineers, technicians, coordinators and project
              managers.
            </p>
          </div>
        </div>
      </div>

      <div className="text-white" style={{ backgroundColor: "#023c7a" }}>
        <div className="container-fluid py-5">
          <div className="me-47 ms-47">
            <p className="fs-56 lh-64 gilroy-bold text-center">
              Register at{" "}
              <a
                href="https://ustaze.com"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none text-orange-ryb"
              >
                ustaze.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildCareer;
